module.exports = "footer {\n  max-width: 1140px;\n  margin: 50px auto 100px;\n  text-align: center;\n}\nfooter div {\n  padding: 0 15px 15px 15px;\n}\n"